import { FC } from "react";

import { LoadingElement } from "@app/components/common/LoadingElement";
import { StyledLoadingOverlay } from "@app/components/common/LoadingOverlay.styles";
import { useStickyLoadingMessage } from "@app/components/common/useStickyLoadingMessage";
import { useDataId } from "@dit/ui-core-hooks";
import { getDebugLogger } from "@app/core/devtools";

const log = getDebugLogger("render:flow");

type Props = {
    loading: boolean;
    loadingMessage?: string;
};

export const LoadingPage: FC<Props> = ({ loading, loadingMessage }) => {
    const { getManualId } = useDataId(LoadingPage);
    const stickyMessage = useStickyLoadingMessage(loadingMessage, loading);

    log("LoadingPage-render", { loading, message: loadingMessage });

    return (
        <StyledLoadingOverlay $loading={loading} $variant="fixed" data-id={getManualId("page-loader")}>
            <LoadingElement loadingMessage={stickyMessage} />
        </StyledLoadingOverlay>
    );
};

LoadingPage.displayName = "LoadingPage";
